const getWishlist = state => state.wishlist

export default {
    getWishlist
}